import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-pre-log-tips',
    templateUrl: './pre-log-tips.component.html',
    styles: [],
    standalone: false
})
export class PreLogTipsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
